import {Button} from 'antd'
import classNames from 'classnames'
import React from 'react'
import './CustomButton.css'
import useTranslate from "../../../modules/local/useTranslate";

const CustomButton = ({
    label,
    size,
    className,
    useDefaultStyles = true,
    textSize = 'text-sm',
    ...props
}) => {
    const t = useTranslate()
    return (
        <Button
            {...props}
            size={size ? size : 'default'}
            className={classNames(
                'CustomButton no-text-shadow no-shadow',
                useDefaultStyles && 'px-2 rounded-md font-medium',
                className, textSize
            )}>
            {label && t(label)}
        </Button>
    )
}

export default CustomButton
